'use strict';

/**
 * @ngdoc function
 * @name ribytRsvpApp.controller:PersonalinformationCtrl
 * @description
 * # PersonalinformationCtrl
 * Controller of the ribytRsvpApp
 */
angular.module( 'ribytRsvpApp' )
    .controller( 'PersonalinformationCtrl', [ '$rootScope', '$scope', 'ENV', '$http', '$sessionStorage', 'notificationService', 'Cropper', '$timeout', '$location', '$anchorScroll', 'variableSubstitution', '$sce', 'messageDictionary', 'RibytUtils', function ( $rootScope, $scope, ENV, $http, $sessionStorage, notificationService, Cropper, $timeout, $location, $anchorScroll, $variableSubstitution, $sce, $messageDictionary, RibytUtils ) {
        $rootScope.bannerImage = true;
        $rootScope.isTicketPage = false;
        $rootScope.isLandingPage = true;
        // set this tab just incase it was unset by using the back button
        $rootScope.showTabs = true;
        $rootScope.currentTab = 'guestProfile';

        /**
         * Set controller vars
         */
        var invite = $rootScope.decryptInvite( _.get( $sessionStorage, 'invitation' ) );

        _.set( $scope, 'inviteType', invite.type );
        _.set( $scope, 'requiredField', $messageDictionary.general.required );
        _.set( $scope, 'disableSave', false );
        _.set( $scope, 'cropper', {} );
        _.set( $scope, 'formattedBirthday', [ '', '', '' ] );

        var imageFile;

        /**
         * Set scope Functions
         */
        $scope.savePersonalInformation = savePersonalInformation;
        $scope.cropOnFile = cropOnFile;
        $scope.cropClear = cropClear;
        $scope.cropPreview = cropPreview;
        $scope.cropShowEvent = 'show';
        $scope.cropHideEvent = 'hide';
        $scope.updateAnswersRequired = updateAnswersRequired;
        $scope.legalsWithSSN = false;

        $scope.searchAirports = RibytUtils.searchAirports;
        $scope.selectAirport = function selectAirport ( item ) {
            $scope.guestInfo.travelPreferences.departureAirport = RibytUtils.stringVersionOfAirport( item );
        };

        /**
         * Remove social...never need it here
         */
        _.set( invite, 'guestID.ssn', '' );

        /**
         * Image cropper options
         */
        _.set( $scope, 'cropOptions', {
            'maximize': true,
            'aspectRatio': 1,
            'crop': function ( dataNew ) {
                _.set( $scope, 'guestInfo.imageData', dataNew );
            }
        } );

        /**
         * Set birthday stuff
         */
        if ( _.get( invite, 'guestID.birthdayDate', [] ) && _.get( invite, 'guestID.birthdayDate', [] ).length ) {
            var bday = _.get( invite, 'guestID.birthdayDate', [] );

            var separator = bday.match( /[-\/]/ );

            if ( separator && separator[ 0 ] ) {
                _.set( $scope, 'formattedBirthday', bday.split( separator[ 0 ] ) );
            }
        }

        /**
         * Set b-day ranges
         */
        _.set( $scope, 'days', _.range( 1, 32 ) );
        _.set( $scope, 'years', _.reverse( _.range( 1900, moment().year() - 13 ) ) );

        /**
         * Pass only the necessary stuff into scope for security.
         */
        _.set( $scope, 'guestInfo', _.get( invite, 'guestID' ) );
        _.set( $scope, 'guestInfo.email.primary', _.get( $rootScope, 'guestSignInData.email' ) );
        _.set( $scope, 'guestInfo.phone.sms.isOptOut', _.get( invite, 'guestID.phone.sms.isOptout', '0' ) );

        var ffData = _.get( invite, 'guestID.travelPreferences.frequentFlyer', {} );
        var ffProgram = _.keys( _.get( invite, 'guestID.travelPreferences.frequentFlyer' ) )[ 0 ];
        var ffNumber = _.get( ffData, ffProgram );

        _.set( $scope, 'guestInfo.travelPreferences.ffProgram', ffProgram );
        _.set( $scope, 'guestInfo.travelPreferences.ffNumber', ffNumber );

        _.set( $scope, 'invite.isForfeitHotel', _.get( invite, 'isForfeitHotel' ) );
        _.set( $scope, 'invite.isForfeitAir', _.get( invite, 'isForfeitAir' ) );
        _.set( $scope, 'guestInformation', _.get( invite, 'experienceID.guestInformation' ) );

        _.set( $scope, 'legals', _.get( invite, 'legals', [] ) );
        _.set( $scope, 'surveyAnswers', [] );
        _.set( $scope, 'trackAnswersRequired', {} );
        _.set( $scope, 'officialRules', _.get( invite, 'experienceID.guestInformation.officialRules' ) );
        _.set( $scope, 'RSVPDetails', _.get( invite, 'experienceID.RSVPDetails' ) );

        // if there are official rules, make sure we do any substitutions on it
        if ( $scope.officialRules ) {
            $scope.officialRules = $variableSubstitution.doSubstitutions( $scope.officialRules );
        }

        // we give full trust that the code in our database is safe. Otherwise, we get some other issues with styling not being displayed properly
        $scope.trustedHtml = function ( plainText ) {
            return $sce.trustAsHtml( plainText );
        };

        /**
         * Set a profile image if they have one
         */
        _.each( _.get( invite, 'images' ), function ( image ) {
            if ( _.get( image, 'id' ) === _.get( invite, 'guestID.pictureID' ) ) {
                _.set( $scope, 'guestInfo.imageData', $rootScope.AWS.prefix + _.get( image, 'awsPath' ) );
            }
        } );

        /**
         * Set the air/hotel decline options
         */

        var byts = _.get( invite, 'byts', [] );
        var airByts = [];
        var hotelByts = [];
        byts.map( function ( byt ) {
            if ( byt.type === 'Air' ) {
                airByts.push( byt );
            } else if ( byt.type === 'Hotel' ) hotelByts.push( byt );
        } );
        $scope.showAirDeclineOption = false;
        $scope.showHotelDeclineOption = false;
        // Only show if they have qty, it's enabled, and it's accepted
        RibytUtils.defineBytVisibility( airByts, 'showAirDeclineOption', $scope, invite );
        RibytUtils.defineBytVisibility( hotelByts, 'showHotelDeclineOption', $scope, invite );

        /*
        Show the SSN input field only if there are legals that require SSN
        */

        // get all the type of legals for this person
        _.each( invite.experienceID.legals, function ( legal ) {
            switch ( invite.type ) {
            case 'i':
                    // for invite type i (guest), we will check if any of the legals for that type of guest have custom fields that say Guest SSN
                if ( _.get( legal, 'type.guest' ) && _.filter( _.get( invite, 'legals', {} ), {
                    'id': legal.legalID
                } ) ) {
                    _.each( invite.legals, function ( leg ) {
                        if ( leg.id === legal.legalID && !$scope.legalsWithSSN ) {
                            if ( _.get( leg, 'helloSign.customFields', [] ).length > 0 ) {
                                    // get the corresponding fields for that particular legal
                                $scope.legalsWithSSN = _.find( _.get( leg, 'helloSign.customFields', [] ), function ( cF ) {
                                    if ( cF.name === 'Guest SSN' ) {
                                        return legal;
                                    }
                                } );
                            }
                        }
                    } );
                }
                break;
            case 'g':
                    // for invite type g (companion), we will check if any of the legals for that type of guest have custom fields that say Guest SSN
                if ( _.get( legal, 'type.companion' ) && _.filter( _.get( invite, 'legals', {} ), {
                    'id': legal.legalID
                } ) ) {
                    _.each( invite.legals, function ( leg ) {
                        if ( leg.id === legal.legalID && !$scope.legalsWithSSN ) {
                            if ( _.get( leg, 'helloSign.customFields', [] ).length > 0 ) {
                                    // get the corresponding fields for that particular legal
                                $scope.legalsWithSSN = _.find( _.get( leg, 'helloSign.customFields', [] ), function ( cF ) {
                                    if ( cF.name === 'Guest SSN' ) {
                                        return legal;
                                    }
                                } );
                            }
                        }
                    } );
                }
                break;
            }
        } );

        /**
         * surveyAnswers are stored differently then how we collect them here. Do the conversion
         * so we have existing values in the proper form.
         */
        var tmpSurveyAnswers = {};
        _.each( _.get( invite, 'surveyAnswers', [] ), function ( s ) {
            // Try to JSON encode the answer. If it works, then it's an array
            var tmpParsedAnswer = '';
            var parsedAnswer = '';
            try {
                tmpParsedAnswer = JSON.parse( _.get( s, 'answer' ) );

                /**
                 * If answers is an array, then the options must be multipl select.
                 */
                if ( Array.isArray( tmpParsedAnswer ) ) {
                    parsedAnswer = {};

                    _.each( tmpParsedAnswer, function ( a ) {
                        parsedAnswer[ a ] = true;
                    } );
                } else {
                    parsedAnswer = tmpParsedAnswer;
                }
            } catch ( e ) {
                // Could not parse it as JSON/Array so we treat it like a string.
                parsedAnswer = _.get( s, 'answer' );
            }

            tmpSurveyAnswers[ _.get( s, 'question' ) ] = parsedAnswer;
        } );
        _.set( $scope, 'surveyAnswers', tmpSurveyAnswers );

        /**
         * Set the flags to show/hide whole sections
         */

        // to determine if we will show the survey questions for a companion, we will do so here
        var guestOrCompanion = {};
        if ( $scope.inviteType === 'g' ) {
            guestOrCompanion.companion = true;
        } else if ( $scope.inviteType === 'i' ) {
            guestOrCompanion.guest = true;
        }

        var paramRequiredDefinitions = {
            'personal': {
                'gender': true,
                'dob': true,
                'profileImage': false,
                'dietaryRestrictions': false,
                'specialNeeds': false,
                'socialMedia': false
            },
            'contact': {
                'phone': {
                    'primary': true,
                    'alternate': false
                },
                'address': true,
                'companyName': false,
                'title': false
            },
            'travel': {
                'homeAirport': true,
                'departureTime': true,
                'returnTime': true,
                'frequentFlyerNo': false,
                'knownTravelerNo': false,
                'seatPreference': false
            }
        };

        if ( _.has( $scope, 'guestInformation' ) && _.isEmpty( _.get( $scope, 'guestInformation.paramsRequired' ) ) ) {
            _.set( $scope, 'guestInformation.paramsRequired', paramRequiredDefinitions );
        }

        if ( $scope.inviteType === 'g' && _.get( invite, 'experienceID.RSVPDetails.isCompanionParamsDisabled' ) === false ) {
            $scope.guestInformation.params = _.cloneDeep( $scope.guestInformation.companionParams );
            $scope.guestInformation.paramsRequired = _.cloneDeep( $scope.guestInformation.companionParamsRequired );
        }

        // gathering of email is handled elsewhere, we need to remove it from params.contact, for calculation of showContactInfo
        _.unset( $scope, 'guestInformation.params.contact.email' );

        /**
         * Show/Hide Travel + hotel based on byts available
         */
        $scope.showTravelInfo = $scope.showAirDeclineOption || $scope.showHotelDeclineOption;

        _.set( $scope, 'showPersonalInfo', true ); // Always show
        _.set( $scope, 'showContactInfo', _.some( RibytUtils.flattenObject( _.get( $scope, 'guestInformation.params.contact' ) ), Boolean ), false );
        _.set( $scope, 'showTravelInfo', _.some( RibytUtils.flattenObject( _.get( $scope, 'guestInformation.params.travel' ) ), Boolean ), false );
        _.set( $scope, 'showAdditionalInfo', _.some( _.get( $scope, 'guestInformation.surveyQuestions' ), guestOrCompanion ), false );

        /**
         * Check if this is a gid registration. If so, set the flag to show email
         */
        if ( _.get( $rootScope, 'parameters.gid' ) && !invite.inviteHash ) {
            _.set( $scope, 'guestInformation.params.contact.email', true );
        } else {
            _.set( $scope, 'guestInformation.params.contact.email', false );
        }
        /**
         * Functions
         */
        function savePersonalInformation ( $event ) {
            $event.preventDefault();

            $scope.submitted = true;
            if ( _.get( $scope, 'guestInformation.params.personal.profileImage' ) && _.get( $scope, 'guestInformation.paramsRequired.personal.profileImage' ) && !_.get( $scope, 'guestInfo.imageData' ) ) {
                _.set( $scope, 'showProfileImageIsRequiredError', true );
            }
            if ( _.get( $scope, 'showProfileImageIsRequiredError' ) || _.get( $scope, 'personalInformation.$error.required.length' ) > 0 ) {
                $location.hash( $scope.personalInformation.$error[ 0 ] );
                $anchorScroll( $scope.personalInformation.$error[ 0 ] );
                notificationService.error( 'Please make sure you fill in all the required fields.' );
                return;
            }

            _.set( $scope, 'disableSave', true );

            var updateData = {};

            // Setup survey answers
            var surveyAnswers = [];
            var tmpSurveyAnswers = _.get( $scope, 'surveyAnswers' );

            _.each( tmpSurveyAnswers, function each ( v, k ) {
                // only generate something for non statements
                if ( v && !v.isStatement ) {
                    if ( typeof v === 'string' ) {
                        surveyAnswers.push( {
                            'question': k,
                            'answer': v
                        } );
                    } else {
                        /**
                         * If the value is not a string, it's for a multi select so make it
                         * a stringified array.
                         */
                        var multipleValues = [];
                        _.each( v, function each ( avalue, akey ) {
                            if ( avalue ) {
                                multipleValues.push( akey );
                            }
                        } );

                        surveyAnswers.push( {
                            'question': k,
                            'answer': JSON.stringify( multipleValues )
                        } );
                    }
                }
            } );
            _.set( updateData, 'surveyAnswers', surveyAnswers );

            // Fix boolean for phone SMS
            var isOptOut = _.get( $scope, 'guestInfo.phone.sms.isOptOut' );
            _.set( $scope, 'guestInfo.phone.sms.isOptOut', ( isOptOut === '1' ) ? 1 : 0 );

            // Set remaining data values
            _.set( updateData, 'guestInfo.name', _.get( $scope, 'guestInfo.name' ) );
            _.set( updateData, 'guestInfo.phone', _.get( $scope, 'guestInfo.phone' ) );
            _.set( updateData, 'guestInfo.address', _.get( $scope, 'guestInfo.address' ) );
            _.set( updateData, 'guestInfo.ssn', _.get( $scope, 'guestInfo.ssn' ) );
            _.set( updateData, 'guestInfo.birthdayDate', _.get( $scope, 'formattedBirthday', [] ).join( '-' ) );
            _.set( updateData, 'guestInfo.gender', _.get( $scope, 'guestInfo.gender' ) );
            _.set( updateData, 'guestInfo.optIn', _.get( $scope, 'guestInfo.optIn' ) );
            _.set( updateData, 'guestInfo.companyName', _.get( $scope, 'guestInfo.companyName' ) );
            _.set( updateData, 'guestInfo.preferences', _.get( $scope, 'guestInfo.preferences' ) );
            _.set( updateData, 'guestInfo.socialMedia', _.get( $scope, 'guestInfo.socialMedia' ) );
            _.set( updateData, 'guestInfo.travelPreferences', angular.copy( _.get( $scope, 'guestInfo.travelPreferences' ) ) );
            _.set( updateData, 'forfeits.[0].isForfeitAir', _.get( $scope, 'invite.isForfeitAir', false ) );
            _.set( updateData, 'forfeits.[0].isForfeitHotel', _.get( $scope, 'invite.isForfeitHotel', false ) );

            /**
             * Travel preferences is different. The
             */
            // ffProgram, ffNumber
            var ffProgram = _.get( updateData, 'guestInfo.travelPreferences.ffProgram' );
            var ffNumber = _.get( updateData, 'guestInfo.travelPreferences.ffNumber' );

            if ( ffProgram && ffNumber ) {
                var currentFF = _.get( $scope, 'guestInfo.travelPreferences.frequentFlyer' ) || {};

                currentFF[ ffProgram ] = ffNumber;

                _.set( updateData, 'guestInfo.travelPreferences.frequentFlyer', currentFF );
                delete updateData.guestInfo.travelPreferences.ffProgram;
                delete updateData.guestInfo.travelPreferences.ffNumber;
            }

            // Check the next step and set the rsvp
            _.set( updateData, 'rsvpProcess', $rootScope.getNextRSVPProcess( invite ) );
            _.set( $rootScope, 'rsvpProcess', 'guestProfile' );

            // RPT-3011: For quick fix adding event here due to overwrite of the invite below
            // The rsvp api seems to respond with an unpopulated invite as eventID should be populated
            var event = _.get( invite, 'eventID' );
            /**
             * If they get here through a gid, then we have to create and save invite data first then save the profile image. If it's a regular invitation they will already have an inviteHash so we're good to go.
             */
            if ( _.get( $rootScope, 'parameters.gid' ) && !invite.inviteHash && $rootScope.rsvpProcess !== 'welcome' ) {
                _.set( updateData, 'guestInfo.email.primary', _.get( $scope, 'guestInfo.email.primary' ) );

                // this is from fake invite data, it has no hash yet
                // we create the real invite in the upcoming post, which hits the main apis public reg route currently
                var inviteData = {
                    'eventID': _.get( invite, 'eventID.id' ),
                    'experienceID': _.get( $rootScope, 'parameters.gid' ),
                    'guests': [
                        updateData
                    ],
                    'isBulkImport': false,
                    'isDraft': false,
                    'suppressEmailSend': true,
                    'invite': {
                        'surveyAnswers': surveyAnswers
                    }
                };

                // create public reg invite, return unpopulated invite object with a hash
                $http.post( ENV.apiEndpoint + '/ribyt/rsvp/', inviteData )
                .then( function success ( resp ) {
                    // the invite.legals needs to be preserved after the update of guest profile
                    var legalPreserves = invite.legals;
                    // decrypt the unpopulated invite
                    invite = $rootScope.decryptInvite( _.get( resp, 'data.data' ) );
                    // use the hash to find the typically returned encrypted invite object
                    $http
                    .get( ENV.apiEndpoint + '/ribyt/rsvp/' + _.get( invite, 'inviteHash', 'unknown' ) )
                    .then( function success ( resp ) {
                        // decrypt the populated invite returned from the hash
                        invite = $rootScope.decryptInvite( _.get( resp, 'data.data' ) );

                        // Update the rest fo the important data
                        _.set( invite, 'isForfeitAir', _.get( updateData, 'forfeits.[0].isForfeitAir' ) );
                        _.set( invite, 'isForfeitHotel', _.get( updateData, 'forfeits.[0].isForfeitHotel' ) );
                        _.set( invite, 'surveyAnswers', _.get( updateData, 'surveyAnswers' ) );
                        _.set( invite, 'rsvpProcess', _.get( updateData, 'rsvpProcess' ) );

                        // put back the legals after the update
                        if ( legalPreserves ) {
                            _.set( invite, 'legals', legalPreserves );
                        }
                        // Save to sessionStorage
                        _.set( $sessionStorage, 'inviteHash', _.get( invite, 'inviteHash' ) );
                        _.set( $sessionStorage, 'invitation', $rootScope.encryptInvite( invite ) );

                        uploadProfileImage( function uploadImage () {
                            $rootScope.redirectProperly( invite );
                        } );
                    }, function profileSaveError ( err ) {
                        notificationService.error( _.get( err, 'data.data', 'There was an error saving your profile information.' ) );
                        _.set( $scope, 'disableSave', false );
                    } );
                }, function profileSaveError ( err ) {
                    notificationService.error( _.get( err, 'data.data', 'There was an error saving your profile information.' ) );
                    _.set( $scope, 'disableSave', false );
                } );
            } else {
                uploadProfileImage( function uploadImage () {
                    // Always get the invite on load
                    $http.put( ENV.apiEndpoint + '/ribyt/rsvp/' + _.get( invite, 'inviteHash', 'unknown' ), updateData )
                        .then( function success ( resp ) {
                            // Response is a guest record. Update it in the stored invite
                            var guest = $rootScope.decryptInvite( resp.data.data );
                            _.set( invite, 'guestID', guest );

                            // Update the rest fo the important data
                            _.set( invite, 'isForfeitAir', _.get( updateData, 'forfeits.[0].isForfeitAir' ) );
                            _.set( invite, 'isForfeitHotel', _.get( updateData, 'forfeits.[0].isForfeitHotel' ) );
                            _.set( invite, 'surveyAnswers', _.get( updateData, 'surveyAnswers' ) );
                            _.set( invite, 'rsvpProcess', _.get( updateData, 'rsvpProcess' ) );

                            // Save to sessionStorage
                            _.set( $sessionStorage, 'invitation', $rootScope.encryptInvite( invite ) );

                            $rootScope.redirectProperly( invite, { reload: !_.get( $rootScope, 'parameters.gid' ) } );
                        }, function profileSaveError () {
                            notificationService.error( 'There was an error saving your profile information.' );
                            _.set( $scope, 'disableSave', false );
                        } );
                } );
            }
        }

        /**
         * for tracking answers on multiple choice questions to help decipher if the section
         * is required
         */
        function updateAnswersRequired ( idx, answer ) {
            if ( !answer ) {
                $scope.trackAnswersRequired[ idx ].pop();
            } else {
                $scope.trackAnswersRequired[ idx ].push( answer );
            }
        }

        $scope.answeredQuestions = function ( object ) {
            return object ? Object.values( object ).filter( Boolean ) : [];
        };

        /**
         * Method is called every time file input's value changes.
         * Because of Angular has not ng-change for file inputs a hack is needed -
         * call `angular.element(this).scope().onFile(this.files[0])`
         * when input's event is fired.
         */
        function cropOnFile ( blob ) {
            if ( blob ) {
                Cropper.encode( ( imageFile = blob ) ).then( function ( dataUrl ) {
                    $scope.dataUrl = dataUrl;
                    $timeout( showCropper ); // wait for $digest to set image's src
                } );
            }
        }
        /**
         * When there is a cropped image to show encode it to base64 string and
         * use as a source for an image element.
         */
        function cropPreview () {
            if ( !imageFile || !_.get( $scope, 'guestInfo.imageData' ) ) {
                return;
            }

            // set a delay because guestInfo.imageData in the front end will crap out if it's not ready yet
            $scope.profileDelay = true;
            Cropper.crop( imageFile, _.get( $scope, 'guestInfo.imageData' ) ).then( Cropper.encode ).then( function cropperImageFunction ( imageData ) {
                $scope.profileDelay = false;
                _.set( $scope, 'guestInfo.imageData', imageData );
                _.set( $scope, 'dataUrl', null );
                _.set( $scope, 'showProfileImageIsRequiredError', false );
                hideCropper();
                // hide the modal
                $( '#cropperModal' ).modal( 'hide' );
            } );
        }

        /**
         * Use cropper function proxy to call methods of the plugin.
         * See https://github.com/fengyuanchen/cropper#methods
         */
        function cropClear () {
            // Clone the file elm to clear it.
            var imageElm = $( '#pictureFile' );
            imageElm.replaceWith( imageElm = imageElm.clone( true ) );

            _.set( $scope, 'guestInfo.imageData', null );
            _.set( $scope, 'dataUrl', null );
            hideCropper();
        }

        function showCropper () {
            $scope.$broadcast( $scope.cropShowEvent );
        }

        function hideCropper () {
            $scope.$broadcast( $scope.cropHideEvent );
        }

        /**
         * Image upload.
         */
        function uploadProfileImage ( cb ) {
            var localImage = dataURItoBlob( _.get( $scope, 'guestInfo.imageData', null ) );

            /**
             *  At this point, localImage is the cropped Blob object while imageFile is the original
             *  File object.
             */
            if ( _.get( localImage, 'size' ) ) {
                var form = new FormData();
                form.append( 'file', localImage, _.get( imageFile, 'name', 'unknown' ) );

                var settings = {
                    'async': true,
                    'crossDomain': true,
                    'url': ENV.apiEndpoint + '/ribyt/rsvp/' + _.get( $sessionStorage, 'inviteHash' ) + '/uploadImage',
                    'method': 'POST',
                    'headers': {},
                    'processData': false,
                    'contentType': false,
                    'mimeType': 'multipart/form-data',
                    'data': form
                };

                $.ajax( settings ).done( function ( response ) {
                    return cb( response );
                } )
                    .fail( function () {
                        notificationService.error( 'There was an error saving your image. Please select another one and try again.' );
                    } );
            } else {
                // They didnt' upload a file...just keep going.
                cb( null );
            }
        }

        function dataURItoBlob ( dataURI ) {
            // convert base64 to raw binary data held in a string
            // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
            if ( !dataURI || dataURI.match( /^http/ ) ) {
                return false;
            }

            var byteString = atob( dataURI.split( ',' )[ 1 ] );

            // separate out the mime component
            var mimeString = dataURI.split( ',' )[ 0 ].split( ':' )[ 1 ].split( ';' )[ 0 ];

            // write the bytes of the string to an ArrayBuffer
            var ab = new ArrayBuffer( byteString.length );
            var ia = new Uint8Array( ab );
            for ( var i = 0; i < byteString.length; i++ ) {
                ia[ i ] = byteString.charCodeAt( i );
            }

            // write the ArrayBuffer to a blob, and you're done
            var blob = new Blob( [ ab ], {
                'type': mimeString
            } );
            return blob;

            // Old code
            // var bb = new BlobBuilder();
            // bb.append(ab);
            // return bb.getBlob(mimeString);
        }
    } ] );
